import type { IPage } from "@framework/types";

export const pageFilter = ({ id: _id, ...rest }: IPage) => rest;

export const preparePageInitialValues = ({ id, title, description, slug, pageStatus }: Partial<IPage>) => {
  return {
    id,
    title,
    description,
    slug,
    pageStatus,
  };
};
